var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { logErrorToSentry } from './sentry';
export function getVideoThumbnail(videoHref) {
    return __awaiter(this, void 0, void 0, function () {
        var youtubeVideoId, vimeoId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (videoHref.includes('youtube') || videoHref.includes('youtu.be')) {
                        youtubeVideoId = getYoutubeVideoId(videoHref);
                        return [2 /*return*/, "https://img.youtube.com/vi/".concat(youtubeVideoId, "/hqdefault.jpg")];
                    }
                    if (!videoHref.includes('vimeo')) return [3 /*break*/, 3];
                    vimeoId = extractVimeoId(videoHref);
                    if (!vimeoId) return [3 /*break*/, 2];
                    return [4 /*yield*/, getVimeoThumb(vimeoId)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, ''];
                case 3: 
                // If the video is neither youtube or vimeo, then it's direct upload
                // these do not need thumbnail work doing to them
                return [2 /*return*/, videoHref];
            }
        });
    });
}
function getVimeoThumb(id) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "https://vimeo.com/api/v2/video/".concat(id, ".json");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP error! status: ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    return [2 /*return*/, data[0].thumbnail_large];
                case 4:
                    error_1 = _a.sent();
                    logErrorToSentry(new Error('unable to get Vimeo thumbnail'), null, {
                        url: url,
                        videoId: id,
                    });
                    return [2 /*return*/, ''];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getYoutubeVideoId(url) {
    var regex = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
    var urlMatch = regex.exec(url);
    if (!urlMatch) {
        return '';
    }
    return urlMatch[3];
}
function extractVimeoId(url) {
    var regExp = /vimeo\.com\/([0-9]{6,11})/;
    var match = url.match(regExp);
    return match ? match[1] : null;
}
